import React from "react";
import Modal from "react-bootstrap/Modal";
import "react-slidedown/lib/slidedown.css";
import MealMenuItem from "./MealMenuItem";
import { Scrollbars } from "react-custom-scrollbars";
export default class MealMenuModal extends React.Component {
    constructor(props) {
        super(props);
        this.onEnter = () => {
            if (this.allergenRef.current) {
                //@ts-ignore: JQuery plugin
                $(this.allergenRef.current).selectpicker({
                    multipleSeparator: ", ",
                    noneSelectedText: "Allergens",
                    selectedTextFormat: "count > 1",
                    iconBase: "fa-regular",
                    tickIcon: "fa-xmark",
                });
            }
            if (this.meatsRef.current) {
                //@ts-ignore: JQuery plugin
                $(this.meatsRef.current).selectpicker({
                    iconBase: "fa-regular",
                    tickIcon: "fa-xmark",
                });
            }
            if (this.dietRef.current) {
                //@ts-ignore: JQuery plugin
                $(this.dietRef.current).selectpicker({
                    iconBase: "fa-regular",
                    tickIcon: "fa-xmark",
                });
            }
        };
        this.selectItem = (product) => {
            this.props.onUpdate(this.props.selectedMeal, product);
            setTimeout(() => this.showModal(false), 100);
        };
        this.state = {
            show: props.show || false,
            filters: {
                search: "",
                diet: "",
                allergens: [],
                meat: "",
            },
        };
        this.allergenRef = React.createRef();
        this.meatsRef = React.createRef();
        this.dietRef = React.createRef();
    }
    //T will be ChangeEvent<HtmlSelectElement | HtmlInputElement>
    updateFilter(e) {
        const { name, value } = e.target;
        switch (name) {
            case "search":
                this.setState((prevState) => ({
                    filters: Object.assign(Object.assign({}, prevState.filters), { search: value }),
                }));
                break;
            case "allergens":
                this.setState((prevState) => ({
                    filters: Object.assign(Object.assign({}, prevState.filters), { allergens: Array.from(e.target
                            .selectedOptions, (option) => option.value) }),
                }));
                break;
            case "meats":
                this.setState((prevState) => ({
                    filters: Object.assign(Object.assign({}, prevState.filters), { meats: value }),
                }));
                break;
            case "diet":
                this.setState((prevState) => ({
                    filters: Object.assign(Object.assign({}, prevState.filters), { diet: value }),
                }));
                break;
        }
    }
    //Filter the meals by the user inputted filters
    filteredMeals(meals) {
        if (typeof meals == "undefined")
            return undefined;
        const { allergens, diet, search } = this.state.filters;
        return meals.filter((meal) => {
            var _a, _b, _c, _d, _e;
            //Remove items with selected allergens
            const allergenSet = new Set((_a = meal.allergens) === null || _a === void 0 ? void 0 : _a.map((i) => i.toString()));
            if (allergens.some((val) => allergenSet.has(val)))
                return false;
            //Remove items that don't match selected diet
            if (diet !== "") {
                if (meal.tags &&
                    !meal.tags.includes(parseInt(this.state.filters.diet))) {
                    return false;
                }
            }
            //Remove items that don't make search criteria
            if (search !== "") {
                return (((_b = meal.allergens_text) === null || _b === void 0 ? void 0 : _b.toLowerCase().includes(search.toLowerCase())) ||
                    ((_c = meal.ingredients_text) === null || _c === void 0 ? void 0 : _c.toLowerCase().includes(search.toLowerCase())) ||
                    ((_d = meal.product_id) === null || _d === void 0 ? void 0 : _d.toString().toLowerCase().includes(search.toLowerCase())) ||
                    ((_e = meal.text) === null || _e === void 0 ? void 0 : _e.toLowerCase().includes(search.toLowerCase())));
            }
            return true;
        });
    }
    render() {
        const { selectedMeal, category, filters, onExit } = this.props;
        const { show } = this.state;
        //console.log(category?.children)
        const filteredMeals = this.filteredMeals(category === null || category === void 0 ? void 0 : category.children);
        return (React.createElement(React.Fragment, null,
            React.createElement(Modal, { show: show, onHide: () => this.showModal(false), dialogClassName: "modal-xxl modal-dialog-centered modal-dialog-scrollable rfg-modal", onEnter: this.onEnter, onExit: onExit, className: "mealSwapModal" },
                React.createElement(Modal.Header, { closeButton: true },
                    React.createElement(Modal.Title, null,
                        React.createElement("h5", { className: "modal-title", id: "simple-modal" }, category === null || category === void 0 ? void 0 : category.text))),
                React.createElement(Modal.Body, null,
                    React.createElement(Scrollbars, null,
                        React.createElement("div", { className: "container-fluid" },
                            React.createElement("div", { className: "card card-body plan-change-modal-filters" },
                                React.createElement("h5", null, "Filters"),
                                React.createElement("div", null,
                                    React.createElement("label", { className: "form-label" }, "Search"),
                                    React.createElement("input", { type: "text", className: "form-control", value: this.state.filters.search, name: "search", onChange: (e) => this.updateFilter(e) })),
                                React.createElement("div", null,
                                    React.createElement("label", { className: "form-label" }, "Allergens to exclude"),
                                    React.createElement("select", { className: "form-control", multiple: true, ref: this.allergenRef, value: this.state.filters.allergens ||
                                            "", name: "allergens", onChange: (e) => this.updateFilter(e) }, filters === null || filters === void 0 ? void 0 : filters.allergens.map((item) => (React.createElement("option", { value: item.id, key: item.id }, item.value))))),
                                React.createElement("div", null,
                                    React.createElement("label", { className: "form-label" }, "Diet"),
                                    React.createElement("select", { className: "form-control", ref: this.dietRef, value: this.state.filters.diet || "", name: "diet", onChange: (e) => this.updateFilter(e) },
                                        React.createElement("option", { value: "" }, "Show all diets"), filters === null || filters === void 0 ? void 0 :
                                        filters.diet.map((item) => (React.createElement("option", { value: item.id, key: item.id }, item.value)))))),
                            React.createElement("h5", null, "Please select one of the options below"),
                            (filteredMeals === null || filteredMeals === void 0 ? void 0 : filteredMeals.length) == 0 && (React.createElement("div", { style: {
                                    textAlign: "center",
                                    padding: 20,
                                } },
                                React.createElement("h4", null, "No products match your criteria"),
                                React.createElement("p", null, "Please adjust your settings to view available meals"))),
                            React.createElement("div", { className: "modal-shop-grid" }, filteredMeals === null || filteredMeals === void 0 ? void 0 : filteredMeals.map((product, idx) => (React.createElement(MealMenuItem, { key: idx, product: product, selectItem: this.selectItem, isSelected: product.id ==
                                    (selectedMeal === null || selectedMeal === void 0 ? void 0 : selectedMeal.variant_id) }))))))))));
    }
    showModal(showOrHide) {
        this.setState({
            show: showOrHide,
        });
    }
    componentDidUpdate(prevProps) {
        //Toggle showing modal
        if (prevProps.show != this.props.show) {
            this.showModal(this.props.show);
        }
    }
}
